<template>
  <div class="permission-alert" :class="{ 'show-alert': isVisible }">
    <div class="alert-content">
      <div class="alert-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <p class="alert-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionAlert',
  props: {
    message: {
      type: String,
      default: 'You do not have permission to view this content',
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  mounted() {
    // Trigger animation after component is mounted
    setTimeout(() => {
      this.isVisible = true
    }, 100)
  },
}
</script>

<style scoped>
.permission-alert {
  margin: 20px 0;
  padding: 16px;
  border-radius: 8px;
  background-color: var(--secondary-color);
  border: 1px solid var(--primary-color);
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease-out;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.show-alert {
  opacity: 1;
  transform: translateY(0);
}

.alert-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.alert-icon {
  color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.alert-message {
  color: var(--primary-color);
  font-family: var(--font-archivo);
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
